import axios from 'axios';
const getServiceInstanceAuthorization = () => {
    var _a;
    const token = (_a = localStorage.getItem('id_token')) !== null && _a !== void 0 ? _a : '';
    return axios.create({
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};
const getServiceInstance = () => axios.create();
export const baseService = {
    getServiceInstanceAuthorization,
    getServiceInstance,
};
